<template>
  <div class="menu-bar">

    <ul v-on:click="onMenuTap" v-on:click="onMenuClick">
      <li class="menu-item"><label>File</label>
        <ul class="dropdown">
          <li data-cmd="new"><label>New</label></li>
          <li data-cmd="showPalette" data-arg="open-dialog"><label>Open...</label></li>

          <!--<li data-cmd="save"><label>Save</label></li>-->
          <li data-cmd="save"><label>Save...</label></li>
          <!--<li data-cmd="showPalette" data-arg="share"><label>Share...</label></li>-->
        </ul>
      </li>
      <li class="menu-item"><label>Edit</label>
        <ul class="dropdown">
          <li data-cmd="undo"><label>Undo</label></li>
          <li data-cmd="erase"><label>Erase</label></li>
        </ul>
      </li>
      <!--
      <li class="menu-item"><label>Font</label>
        <ul class="dropdown">
          <li v-for="(index, font) in state.AVAILABLE_FONTS"
              data-cmd="setFont" data-arg="{{ font.val }}"
              v-bind:class="{checked: state.font==font.val}"><label>{{ font.label }}</label></li>
        </ul>
      </li>
      <li class="menu-item"><label>FontSize</label>
        <ul class="dropdown dropdown-columns" v-for="(i,group) in state.AVAILABLE_FONT_SIZES">
          <li v-for="(j,size) in group" data-cmd="setFontSize" data-arg="{{ size }}"
              v-bind:class="{checked: state.fontSize==size}"><label>{{ size }}</label></li>
        </ul>
      </li>
      <li class="menu-item"><label>Style</label>
        <ul class="dropdown">
          <li v-for="(index, style) in state.AVAILABLE_STYLES"
              data-cmd="setStyle" data-arg="{{ style.val }}"
              v-bind:class="{checked: state.style==style.val}"><label>{{ style.label }}</label></li>
          <li>
            <hr/>
          </li>
          <li data-cmd="setAlignment" data-arg="left" v-bind:class="{checked: state.alignment=='left'}"><label>Align
            left</label></li>
          <li data-cmd="setAlignment" data-arg="center" v-bind:class="{checked: state.alignment=='center'}"><label>Align
            center</label></li>
          <li data-cmd="setAlignment" data-arg="right" v-bind:class="{checked: state.alignment=='right'}"><label>Align
            right</label></li>
          <li>
            <hr/>
          </li>
          <li data-cmd="setTransparent" data-arg="0" v-bind:class="{checked: !state.transparent}"><label>Opaque</label>
          </li>
          <li data-cmd="setTransparent" data-arg="1" v-bind:class="{checked: state.transparent}">
            <label>Transparent</label></li>
        </ul>
      </li>
      -->
      <li class="menu-item"><label>Palette</label>
        <ul class="dropdown">
          <li data-cmd="showPalette" data-arg="colors"><label>Colors...</label></li>
          <li data-cmd="showPalette" data-arg="line-widths"><label>Line Widths...</label></li>
          <li data-cmd="showPalette" data-arg="brushes"><label>Brush Shapes...</label></li>
          <!--<li data-cmd="showPalette" data-arg="tools"><label>Tools...</label></li>-->
        </ul>
      </li>
      <li class="menu-item"><label>Options</label>
        <ul class="dropdown">
          <!--<li data-cmd="zoom" data-arg="1"><label>Zoom In</label></li>-->
          <!--<li data-cmd="zoom" data-arg="-1"><label>Zoom Out</label></li>-->
          <!--<li>-->
            <!--<hr/>-->
          <!--</li>-->
          <li data-cmd="setGrid" data-arg="0" v-bind:class="{checked: state.grid==0}"><label>No Grid</label></li>
          <li data-cmd="setGrid" data-arg="1" v-bind:class="{checked: state.grid==1}"><label>Fine Grid</label></li>
          <li data-cmd="setGrid" data-arg="2" v-bind:class="{checked: state.grid==2}"><label>Medium Grid</label></li>
          <li data-cmd="setGrid" data-arg="3" v-bind:class="{checked: state.grid==3}"><label>Coarse Grid</label></li>
          <!--<li>-->
            <!--<hr/>-->
          <!--</li>-->
          <!--<li data-cmd="palette" data-arg="edit-pattern"><label>Edit Pattern...</label></li>-->
          <!--<li>-->
            <!--<hr/>-->
          <!--</li>-->
          <!--<li data-cmd="display" data-arg="printer" class="checked"><label>For Printer</label></li>-->
          <!--<li data-cmd="display" data-arg="screen"><label>For Screen</label></li>-->

        </ul>
      </li>
    </ul>

  </div>
</template>

<style lang="scss">
  // see menubar.scss
</style>

<script>
  import config from '../data/config';
  import state from '../data/state';

  export default{
    data(){
      return {
        config: config,
        state: state,
      }
    },

    ready() {
      this.$menuItems = $(this.$el).find('.menu-item');
    },

    beforeDestroy() {
      this.removeCloseHandler();
    },

    methods: {

      onMenuTap(e) {
        const $btn = $(e.target);
        if ($btn.is('.menu-item')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.openPopup($btn.index());
        } else {
          return true;
        }
      },

      // capture clicks that would otherwise close the popup
      // when we don't want it to be closed.
      onMenuClick(e) {
        const $btn = $(e.target);
        if ($btn.is('.menu-item')) {
          e.stopImmediatePropagation();
        }
      },

      openPopup(idx){
        var $btn = this.$menuItems.eq(idx);

        if ($btn.is('.open')) {
          // toggle off the one we just opened
          this.closePopups();
        } else {
          // close other popups first
          this.closePopups();

          // open the popup
          $btn.addClass('open');

          // listen for document clicks
          this.closeOnClick();
        }
      },

      closePopups() {
        this.removeCloseHandler();
        this.$menuItems.removeClass('open');
      },

      closeOnClick() {
        this.removeCloseHandler();
        $(document).on('click', this.closePopups);
      },

      removeCloseHandler() {
        $(document).off('click', this.closePopups);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FileMenu.vue?650ff0ad